import {
  CARD_PURCHASE_LOOKUP,
  CHANGE_PASSWORD_CONFIRMATION,
  HOURLY_SCHEDULE,
  NEWSLETTER_CONFIRMATION,
  NEWSLETTER_FORM_RESIGN,
  NEWSLETTER_FORM_WIDGET,
  PWA_INSTRUCTION,
  REGISTER_B2B,
  SWIMMING_COURSE_OFFER,
} from "../../../app/routes";

/* eslint-disable import/no-anonymous-default-export */
export default () => {
  const navbarHiddenRoutes = [
    HOURLY_SCHEDULE,
    NEWSLETTER_FORM_WIDGET,
    NEWSLETTER_CONFIRMATION,
    NEWSLETTER_FORM_RESIGN,
    CHANGE_PASSWORD_CONFIRMATION,
    REGISTER_B2B,
    PWA_INSTRUCTION,
    CARD_PURCHASE_LOOKUP,
    SWIMMING_COURSE_OFFER,
  ];

  const showNavBar = () => {
    if (navbarHiddenRoutes.includes(window.location.pathname)) {
      return false;
    } else {
      return true;
    }
  };

  return showNavBar();
};
